export default __webpack_public_path__ + "static/media/logo-icon-only-white.383fd452.svg";